import { useTranslation } from "react-i18next";
import Popup from "./Popup";

interface ConfirmPopupProps {
    title?: React.ReactNode;
    message: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: "primary" | "danger" | "write-off" | "default";
    onConfirm: () => void;
    onCancel: () => void;
}

/** Shared replacement for window.confirm() — the app's own styled popup instead of the
 *  native browser dialog, for every yes/no confirmation across the app. */
export function ConfirmPopup({ title, message, confirmLabel, cancelLabel, variant = "danger", onConfirm, onCancel }: ConfirmPopupProps) {
    const { t } = useTranslation();
    return (
        <Popup
            title={title}
            message={message}
            onClose={onCancel}
            actions={[
                { label: cancelLabel ?? t("popup.cancel"), variant: "default", onClick: onCancel },
                { label: confirmLabel ?? t("popup.confirm"), variant, onClick: onConfirm },
            ]}
        />
    );
}
